export const TextAndStyleConsentButtonMaxLength = 15;
export const TextAndStyleSettingsButtonMaxLength = 22;
export const TextAndStylePrivacyLinkMaxLength = 40;
export const TextAndStyleDeclineAllButtonMaxLength = 22;
export const TextAndStylePrivacyInfoMaxLength = 300;

export const DO_NOT_SELL_DATA_APPDEFID = '2a617b40-167a-4325-9a9f-58396cf47b93';

export const PrivacyCenterScope = 'scopes.PRIVACYCENTER';
